


























































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Sections
---------------------------------------- */

import Menu from '@layout/Menu.vue';

/** ----------------------------------------
     JS Modules
 ---------------------------------------- */

import { MenuNavigation } from '@js/module/Menu';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            menuNavigation: {}
        }
    },

    components: {
        Menu
    },

    methods: {
        closeMenu: function() {
            this.menuNavigation.close();
        }
    },

    mounted() {
        this.menuNavigation = new MenuNavigation();
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Navigation extends Vue {}

